import type { Tables } from "~/types/types.gen";

export const useGlobalStore = defineStore("globalStore", {
  state: () => ({
    showBackButton: false,
    pageTitle: "",
    navigationData: <NavigationParameters>{},
    fullPageLayout: false, // Removes the padding in layouts/authenticated.vue
    deferredFileForUpload: undefined as File | undefined,
    currencies: <Tables<"currencies">[] | null>null,
    trailingNavigationBarItems: <NavigationBarItem[]>[],
    mobileNavbarPageTitleOpacity: 0,
    navigationBarStyle: NavigationBarStyle.DEFAULT,
  }),
  getters: {},
  actions: {
    clearNavigationData() {
      this.navigationData.entityId = undefined;
      this.navigationData.entityIdSecondary = undefined;
      this.navigationData.mode = undefined;
    },
  },
});

export interface NavigationParameters {
  entityId: string | undefined;
  entityIdSecondary: string | undefined;
  mode: NavigationMode | undefined;
}

export enum NavigationMode {
  READONLY = "readonly",
  EDIT = "edit",
  ADD = "add",
}

export interface NavigationBarItem {
  label?: string;
  icon: string;
  iconClass?: string;
  buttonClass?: string;
  variant?: NavigationBarItemVariant;

  onClick: () => void;

  type?: NavigationBarItemType;

  badge?: {
    icon: string;
    class: string | undefined;
    containerClass: string | undefined;
  };
}

export enum NavigationBarItemVariant {
  SOLID = "solid",
  OUTLINE = "outline",
}

export enum NavigationBarItemType {
  DEFAULT = "default",
  DESTRUCTIVE = "destructive",
  DIVIDER = "divider",
}

export enum NavigationBarStyle {
  DEFAULT = "default",
  ACTION_CENTER = "action_center",
}
